import React, { useContext, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Grid, Paper, Avatar, TextField, Typography, Box } from "@mui/material";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { FormInputText } from "../../components/form-components/FormInputText";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { auth } from "../../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import axios from "axios";
import ShowSnackbar from "../../components/snackbar/snackbar";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { LOGO } from "../../app/utlils";
import { showModal, userDataReducer } from "../../redux/counterSlice";
import { useAdmin } from "../../components/Admin/Admin";

const schema = yup.object().shape({
  user_name: yup.string().required(),
  password: yup.string().max(32).required(),
});

function LoginScreen() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const admin = useAdmin();
  const setAdminContext = admin?.login;

  useEffect(() => {
    sessionStorage.setItem("lastLoginPath", window.location.pathname);
  }, []);

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = methods;

  const login = (data) => {
    try {
      axios
        .post("/loginUser", data)
        .then(function (response) {
          const res = response?.data;

          console.log("=== FULL LOGIN RESPONSE ===");
          console.log("Response:", res);
          console.log("Response.data:", res?.data);
          console.log("Response.data.user:", res?.data?.user);
          console.log("Response.data.role:", res?.data?.role);
          console.log("Response.data.user.role:", res?.data?.user?.role);

          if (!res?.error) {
            // ✅ CRITICAL FIX: Role is nested inside user object!
            // Check both locations: res.data.role AND res.data.user.role
            const roleFromData = res?.data?.role;
            const roleFromUser = res?.data?.user?.role;
            const role = roleFromData || roleFromUser; // Use whichever exists

            console.log("=== ROLE DETECTION ===");
            console.log("Role from data:", roleFromData);
            console.log("Role from user:", roleFromUser);
            console.log("Final role object:", role);
            console.log("Role name:", role?.role_name);

            // ✅ Check if this is a super admin
            // Your role name is "Super Admin" so we compare lowercase
            const roleName = role?.role_name;
            const isSuperAdmin = roleName && roleName.toLowerCase() === "super admin";
            
            console.log("=== SUPER ADMIN CHECK ===");
            console.log("Role name from API:", roleName);
            console.log("Role name lowercase:", roleName?.toLowerCase());
            console.log("Comparing with: 'super admin'");
            console.log("Is Super Admin:", isSuperAdmin);

            let storageData = {
              token: res?.data?.user?.token,
              loggedIn: true,
              user: res?.data?.user || null,
              role: role, // ✅ Use the role we found
              menus: res?.data?.menus || [],
              isSuperAdmin: isSuperAdmin, // ✅ Set the flag
            };

            console.log("=== FINAL STORAGE DATA ===");
            console.log("storageData:", storageData);
            console.log("storageData.role:", storageData.role);
            console.log("storageData.isSuperAdmin:", storageData.isSuperAdmin);

            // Save to sessionStorage
            sessionStorage.setItem("userData", JSON.stringify(storageData));
            
            // Verify it was saved
            const saved = JSON.parse(sessionStorage.getItem("userData"));
            console.log("=== VERIFIED SAVED ===");
            console.log("Saved role:", saved.role);
            console.log("Saved role_name:", saved.role?.role_name);
            console.log("Saved isSuperAdmin:", saved.isSuperAdmin);

            // Dispatch to Redux
            dispatch(userDataReducer(storageData));

            // Set admin context
            if (typeof setAdminContext === "function") {
              setAdminContext(res?.data);
            }

            navigate("/dashboard");
            toast.success("Logged in successfully");
          } else {
            dispatch(
              showModal({
                msg: res?.message,
                error: true,
              })
            );
          }
        })
        .catch(function (error) {
          console.error("Login error:", error);
          dispatch(
            showModal({
              msg: error?.response?.data?.message || "Login failed",
              error: true,
            })
          );
        });
    } catch (err) {
      console.error("Login exception:", err);
      toast.error(err?.message);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit(login);
    }
  };

  const paperStyle = {
    padding: 20,
    maxWidth: "400px",
    margin: "10%",
  };
  const btnstyle = { margin: "8px 0", background: "#E63D24" };

  return (
    <Box
      className="login-page"
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper elevation={10} style={paperStyle} className="bg-light">
        <form onSubmit={handleSubmit(login)}>
          <Grid container>
            <Grid item align="center" m={"auto"}>
              <img src={require("../../assets/logo.png")} alt="" width={200} />
            </Grid>

            <Grid item xs={12} mt={2}>
              <FormInputText
                name="user_name"
                control={control}
                label="User Name"
                errors={errors}
                type="text"
                autofocus={true}
              />
            </Grid>
            <Grid item xs={12}>
              <FormInputText
                name="password"
                control={control}
                label="Password"
                errors={errors}
                type="password"
              />
            </Grid>
          </Grid>

          <Button
            type="submit"
            color="primary"
            variant="contained"
            style={btnstyle}
            fullWidth
          >
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default LoginScreen;